import React, { useRef, useState, useEffect, Suspense } from 'react';
import classnames from 'classnames';

import { FilterContextProvider } from "./context/context";

import { updateFilterUrl } from './helpers/url';
import { filter_items } from './helpers/filters';
import { format_date_datepicker } from './helpers/dates'

const Filters = React.lazy(() => import('./components/Filters'));
const ListView = React.lazy(() => import('./components/ListView'));
import Pagination from './components/Pagination';



const FilterUI = props => {
  const {
    items,
    filterForm,
    filterSettings,
    language
  } = props;


  const sortItems = (data, now) => {
    let has_performances = false;
    if (typeof now == "undefined") {
      now = Date.now();
    }
    data.forEach((item) => {
      let future_timestamps = [];
      if (typeof item.performances != "undefined" && item.performances.length) {
        has_performances = true;
        for (const property in item.performances) {
          let performance_date = parseInt(item.performances[property]) * 1000;
          if (performance_date >= now) {
            future_timestamps.push(performance_date);
          }
        }
        if (future_timestamps.length) {
          const next_timestamp = future_timestamps.reduce((prev, curr) => {
            return (Math.abs(curr - now) < Math.abs(prev - now)) ? curr : prev;
          });
          item.next_performance = next_timestamp;

        }


      }

    });

    if (has_performances) {
      data.sort((a, b) => a.next_performance - b.next_performance);
    }
  }

  sortItems(items);


  const isInitialMount = useRef(true);

  const pagination = filterSettings.pagination;

  const allForms = [...filterForm];
  const [filterNav, setFilterNav] = useState(allForms);
  const [totalItems, setTotalItems] = useState(props.items.length);
  const [filterView, setFilterView] = useState(filterSettings.currentView);
  const [activeFilters, setActiveFilters] = useState(filterSettings.activeFilters);

  const [allItems, setAllItems] = useState(items);
  const [filteredItems, setFilteredItems] = useState(items);
  const [currentPage, setCurrentPage] = useState(filterSettings.pagination.currentPage);
  const [navStatus, setNavStatus] = useState(false);


  const [startDate, setStartDate] = useState(filterSettings.activeFilters.calendar ? filterSettings.activeFilters.calendar.value[0] : false);
  const [endDate, setEndDate] = useState(filterSettings.activeFilters.calendar ? filterSettings.activeFilters.calendar.value[1] : false);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [startDateFormatted, setStartDateFormatted] = useState(format_date_datepicker(startDate))
  const [endDateFormatted, setEndDateFormatted] = useState(format_date_datepicker(endDate))


  const [showTags, setShowTags] = useState(filterSettings.showTags);
  const [filterDropdown, setFilterDropdown] = useState(false);

  const states = {
    filterDropdown, setFilterDropdown,
    showTags, setShowTags,
    startDateFormatted, setStartDateFormatted,
    endDateFormatted, setEndDateFormatted,
    startDateOpen, setStartDateOpen,
    endDateOpen, setEndDateOpen,
    startDate, setStartDate,
    endDate, setEndDate,
    allItems, setAllItems,
    filterView, setFilterView,
    filterNav, setFilterNav,
    activeFilters, setActiveFilters,
    totalItems, setTotalItems,
    filteredItems, setFilteredItems,
    pagination,
    currentPage, setCurrentPage,
    language,
    navStatus, setNavStatus
  };


  const updateItems = () => {
    let results = filter_items(items, activeFilters, filterView);

    if (typeof activeFilters.calendar != "undefined") {
      if (Object.keys(activeFilters.calendar).length > 0 && activeFilters.calendar.constructor === Object && activeFilters.calendar.value[0]) {

        let date = new Date(activeFilters.calendar.value[0]).setHours(0, 0, 0, 0);
        sortItems(results, date)
      }
    }
    setTotalItems(results.length);
    setFilteredItems(results);
    let totalPageCount = Math.ceil(results.length / pagination.perpage);
    if (currentPage > totalPageCount) {
      setCurrentPage(totalPageCount > 0 ? totalPageCount : 1);
    }
    updateFilterUrl(activeFilters, currentPage, filterView);
  }

  const setItems = () => {
    let results = filter_items(items, activeFilters, filterView);
    if (typeof activeFilters.calendar != "undefined") {
      if (Object.keys(activeFilters.calendar).length > 0 && activeFilters.calendar.constructor === Object && activeFilters.calendar.value[0]) {
        let date = new Date(activeFilters.calendar.value[0]).setHours(0, 0, 0, 0);
        sortItems(results, date)
      }
    }
    setTotalItems(results.length);

    setFilteredItems(results);
  }


  const clearAllFilters = () => {
    const a = { ...activeFilters };

    for (const key in a) {
      if (a[key].position !== "top") {
        if (typeof a[key].value == "object") {
          if (a[key].name == "calendar") {
            a[key].value = [false, false];

          } else {
            a[key].value = [];
            a[key].selectedTitles = [];
          }
        } else {
          a[key].value = "";
        }
      }
    }
    setStartDate(false);
    setStartDateFormatted('DD/MM/YYYY');
    setEndDate(false);
    setEndDateFormatted('DD/MM/YYYY');

    setActiveFilters(a);
  }


  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      updateItems();
    }
  }, [activeFilters, currentPage]);

  useEffect(() => {
    setItems();
  }, [items]);




  return (
    <>

      <FilterContextProvider value={states}>
        <div className="container">

          <Filters filterForm={filterForm} clearAllFilters={clearAllFilters} />
          <ListView />
          <Pagination
            className="results-pagination"
            currentPage={currentPage}
            totalCount={totalItems}
            pageSize={pagination.perpage}
            onPageChange={page => setCurrentPage(page)}
          />

        </div>



      </FilterContextProvider>

    </>
  );
}
export default FilterUI;
